export const ADMIN_PERMISSIONS = {
  CREATE_ADMINS: 'create_admins',
  VIEW_ADMINS: 'view_admins',
  EDIT_ADMINS: 'edit_admins',
  DELETE_ADMINS: 'delete_admins',

  CREATE_USERS: 'create_users',
  VIEW_USERS: 'view_users',
  EDIT_USERS: 'edit_users',
  DELETE_USERS: 'delete_users',

  CREATE_PRODUCTS: 'create_products',
  VIEW_PRODUCTS: 'view_products',
  EDIT_PRODUCTS: 'edit_products',
  DELETE_PRODUCTS: 'delete_products',
  PRODUCT_STATUS_CHANGE: 'product_status_change',

  CREATE_CATEGORIES: 'create_categories',
  VIEW_CATEGORIES: 'view_categories',
  EDIT_CATEGORIES: 'edit_categories',
  DELETE_CATEGORIES: 'delete_categories',

  CREATE_WHATSAPP_QUE: 'create_whatsapp_que',
  VIEW_WHATSAPP_QUE: 'view_whatsapp_que',

  VIEW_WHATSAPP_CHAT: 'view_whatsapp_chat',
  EDIT_WHATSAPP_CHAT: 'edit_whatsapp_chat',

  MANAGE_SETTINGS: 'manage_settings',
  VIEW_SETTINGS: 'view_settings',

  VIEW_ADMIN_APP: 'view_admin_app',
  MANAGE_ADMIN_APP: 'manage_admin_app',

  VIEW_STORIES: 'view_stories',
  CREATE_STORIES: 'create_stories',
  EDIT_STORIES: 'edit_stories',
  DELETE_STORIES: 'delete_stories',

  VIEW_BANNER_PRODUCTS: 'view_banner_products',
  EDIT_BANNER_PRODUCTS: 'edit_banner_products',
  CREATE_BANNER_PRODUCTS: 'create_banner_products',
  DELETE_BANNER_PRODUCTS: 'delete_banner_products',

  VIEW_REPORTS: 'view_reports',

  VIEW_COUPON: 'view_coupon',
  CREATE_COUPON: 'create_coupon',
  EDIT_COUPON: 'edit_coupon',
  DELETE_COUPON: 'delete_coupon',

  VIEW_ORDERS: 'view_orders',
  EDIT_ORDERS: 'edit_orders',
  VIEW_CUSTOM_ORDERS: 'view_custom_orders',
  CREATE_CUSTOM_ORDERS: 'create_custom_orders',
  EDIT_CUSTOM_ORDERS: 'edit_custom_orders',

  VIEW_ANALYTICS: 'view_analytics',

  VIEW_REEL_VIDEOS: 'view_reel_videos',
  CREATE_REEL_VIDEOS: 'create_reel_videos',
  EDIT_REEL_VIDEOS: 'edit_reel_videos',
  DELETE_REEL_VIDEOS: 'delete_reel_videos',

  VIEW_EVENT_LOGS: 'view_event_logs',
  VIEW_SERVER_ERRORS: 'view_server_errors',

  VIEW_CRM_SUMMARY: 'view_crm_summary',

  VIEW_NOTIFICATION_QUE: 'view_notification_que',
  CREATE_NOTIFICATION_QUE: 'create_notification_que',

  VIEW_DISPATCH_PLANNER: 'view_dispatch_planner',

  VIEW_DELIVERY_STAFF: 'view_delivery_staff',
  VIEW_PACKING_STAFF: 'view_packing_staff',
  CREATE_STAFF: 'create_staff',
  EDIT_STAFF: 'edit_staff',
  DELETE_STAFF: 'delete_staff',

  VIEW_DISPATCH_HISTORY: 'view_dispatch_history',

  VIEW_CHAT_SUPPORT: 'view_chat_support',

  VIEW_SEO: 'view_seo',
  EDIT_SEO: 'edit_seo',

  VIEW_SPIN_WHEEL: 'view_spin_wheel',
  MANAGE_SPIN_WHEEL: 'manage_spin_wheel',

  UPDATE_CUSTOMER_ADDRESS: 'update_customer_address',
};